import { useRef, useState } from "react";

const INITIAL_FORM = {
    name: "",
    email: "",
    structure: "",
    message: "",
    "bot-field": "",
    "captcha-answer": "",
};

function randomDigit() {
    return Math.floor(Math.random() * 8) + 1;
}

function makeCaptcha() {
    return { a: randomDigit(), b: randomDigit() };
}

function buildNetlifyPayload(form) {
    const params = new URLSearchParams();
    params.append("form-name", "contact");
    params.append("name", form.name);
    params.append("email", form.email);
    params.append("structure", form.structure);
    params.append("message", form.message);
    params.append("bot-field", form["bot-field"]);
    return params.toString();
}

export function useContactForm() {
    const [status, setStatus] = useState("idle");
    const [captcha, setCaptcha] = useState(makeCaptcha);
    const [captchaError, setCaptchaError] = useState(false);
    const [form, setForm] = useState(INITIAL_FORM);
    const successRef = useRef(null);

    const refreshCaptcha = () => setCaptcha(makeCaptcha());

    const handleChange = (e) => {
        if (captchaError) setCaptchaError(false);
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const resetForm = () => {
        setForm(INITIAL_FORM);
        refreshCaptcha();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (form["bot-field"]) {
            setStatus("success");
            return;
        }
        const expected = captcha.a + captcha.b;
        const given = parseInt(form["captcha-answer"], 10);
        if (given !== expected) {
            setCaptchaError(true);
            setForm((p) => ({ ...p, "captcha-answer": "" }));
            refreshCaptcha();
            return;
        }
        setStatus("sending");
        try {
            const response = await fetch("/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Accept: "application/x-www-form-urlencoded",
                },
                body: buildNetlifyPayload(form),
            });
            if (!response.ok && response.status !== 0 && response.status >= 500) {
                throw new Error("netlify-error");
            }
            setStatus("success");
            resetForm();
            requestAnimationFrame(() => {
                if (successRef.current) {
                    successRef.current.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });
        } catch {
            setStatus("error");
        }
    };

    const reopenForm = () => setStatus("idle");

    return {
        status,
        captcha,
        captchaError,
        form,
        successRef,
        handleChange,
        handleSubmit,
        reopenForm,
    };
}
